import AcSwipe from 'ac-components/ac-swiper';
import classNames from 'classnames';
import useResizeObserver from 'hooks/use-resize-observer';
import { useTranslation } from 'hooks/use-translation';
import React, { FC, useState } from 'react';
import styles from './styles.scss';



const TutorsSection: FC = () => {
	const [hover, setHover] = useState<number>();
	const { width } = useResizeObserver()
	const { transData } = useTranslation('tutors.tutors');
	const { list } = transData
	const Card = (item: typeof list[0], hover = false) => {

		return (
			<div className={styles.card}>
				{!hover && <div className={styles["card-img"]}>
					<img src={item.img} alt="" />
				</div>}
				<div className={styles["card-info"]}>
					<div className={styles["card-info-name"]}>
						{item.name}
					</div>
					<div className={styles["card-info-school"]}>
						{item.school}
					</div>
					<div className={styles["card-info-wrap"]}>
						<div className={styles["card-info-subject"]}>
							{item.subject}
						</div>
						<div className={styles["card-info-experience"]}>
							{item.experience}
						</div>
					</div>
					<div className={styles["card-info-introduction"]}>
						<p>{item.introduction}</p>
					</div>
				</div>
			</div>
		)
	}
	const ListRender = list.map((item, index) => {
		return (
			<div key={index} className={styles['li-item']}
				onMouseEnter={() => {
					setHover(item.id)
				}}
				onMouseLeave={() => {
					setHover(undefined)
				}}
			>
				{Card(item)}
				{hover == item.id &&
					<div className={styles.mask} >
						{Card(item, true)}
					</div>
				}
			</div>
		)
	})

	const padding = width >= 768 ? 24 : 16
	return (
		<section className={styles['ac-tutors']}>
			<div className={styles['ac-tutors-container']}>
				<div dangerouslySetInnerHTML={{ __html: transData.title }} />
				<p className={styles.desc}>You can schedule lessons with one or several teachers</p>
				<AcSwipe className={classNames(styles['ac-tutors-banner'], 'ac-tutors-banner')}
					loop
					spaceBetween={width >= 1192 ? 32 : padding}
					pagination={{ clickable: true, }}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					slidesPerGroup={width >= 768 ? 3 : 1}
					loopFillGroupWithBlank={width >= 768}
					slidesPerView={width >= 768 ? 3 : 'auto'}
				>{ListRender}</AcSwipe>
				{width >= 768 &&
					<>
						{width >= 1192 && <img src="https://web-data.zmlearn.com/image/mRYKmXhf8C1LoxHsBJEu2b/img_p4_left%402x.png" alt="" className={styles['tutors-img-1']} />}
						<img src="https://web-data.zmlearn.com/image/eQXcATpV4kJuJkp5CqJJkP/img_P4_night%402x.png" alt="" className={styles['tutors-img-2']} />
						<img src="https://web-data.zmlearn.com/image/7sQsZzFbpf6tTXC2R49AAp/img_P4%402x.png" alt="" className={styles['tutors-img-3']} />
					</>}
			</div>
		</section >
	);
}

export default TutorsSection
